import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import AcquisitionMain from '../Acquisition/AcquisitionMain';
import DeaccessionMain from '../Deaccession/DeaccessionMain';
import Loan from '../Loan/Loan';
import ConservationMain from '../Conservation/ConservationMain';
import TransferCatalogueMain from '../TransferCatalogue/TransferCatalogueMain';
import { styleBg } from '../../../common/Models/Validations';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TAB_COUNT = 5;

export default function ArtifactManagement(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = Math.min(Math.max(Number(searchParams.get('tab')) || 0, 0), TAB_COUNT - 1);

  const handleChange = (event, newValue) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('tab', String(newValue));
      return next;
    }, { replace: true });
  };

  return (
    <PageWrapper>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {[
            { label: "ACQUISITION", index: 0 },
            { label: "DEACCESSION", index: 1 },
            { label: "LOAN REQUEST", index: 2 },
            { label: "CONSERVATION", index: 3 },
            { label: "TRANSFER", index: 4 },
          ].filter(Boolean).map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              {...a11yProps(tab.index)}
              sx={{ width: 200, ml:3, ...styleBg(index, value) }}
            />
          ))}
        </Tabs>
        <CustomTabPanel value={value} index={0}>
          <AcquisitionMain />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <DeaccessionMain />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <Loan />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <ConservationMain />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <TransferCatalogueMain />
        </CustomTabPanel>
      </Box>
    </PageWrapper>
  );
}